import { render, staticRenderFns } from "./ParentalConsent.vue?vue&type=template&id=231ac4ec&scoped=true"
import script from "./ParentalConsent.vue?vue&type=script&lang=js"
export * from "./ParentalConsent.vue?vue&type=script&lang=js"
import style0 from "./ParentalConsent.vue?vue&type=style&index=0&id=231ac4ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ac4ec",
  null
  
)

export default component.exports